var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackHand = function SvgBackHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 46q-4.1 0-7.7-1.875A16.04 16.04 0 0 1 12 38.9L2.4 24.8l.95-.95q1-1.05 2.475-1.2t2.675.7l5.5 3.8V8q0-.85.575-1.425T16 6t1.425.575T18 8v16h4V4q0-.85.575-1.425T24 2t1.425.575T26 4v20h4V6q0-.85.575-1.425T32 4t1.425.575Q34 5.149 34 6v18h4V10q0-.85.575-1.425T40 8t1.425.575T42 10v19.6q0 6.85-4.775 11.625Q32.451 46 25.6 46"
  })));
};
export default SvgBackHand;